export enum Role {
  anonymous = 'anonymous',
  user = 'user',
  realizeEmployee = 'realize-employee',
  realizeDeveloper = 'realize-developer',
  orderManagement = 'order-management',
  admin = 'admin',
}
